module.exports = __webpack_public_path__ + "static/media/life-overview-intro3.ff40c358.png";